import { useQuery } from '@tanstack/react-query';

import { getRebootApplicant } from '@/api/reboot/applicant';

export const rebootApplicantQueryKeys = {
  all: ['reboot-applicant'],
  applicantByOnlineUserIdAndRoundId: (
    onlineUserId: string,
    roundId: string,
  ) => [...rebootApplicantQueryKeys.all, onlineUserId, roundId ?? 'LATEST'],
  partial: () => [...rebootApplicantQueryKeys.all, 'partial'],
};

export function useGetRebootApplicant(onlineUserId: string, roundId: string) {
  return useQuery({
    queryKey: rebootApplicantQueryKeys.applicantByOnlineUserIdAndRoundId(
      onlineUserId,
      roundId,
    ),
    queryFn: () => getRebootApplicant(onlineUserId, roundId),
    retry: 1,
    enabled: !!onlineUserId,
  });
}
